import { Checkbox, Group, Select, Stack, Switch, Text } from '@mantine/core';
import { getExposureSpawnPositions, scenarioMaps } from '../../../../data/maps';
import {
  EXPOSURE_CATEGORY_OPTIONS,
  type ExposureQuickFormState,
} from '../types';
import { previewExposureItemStats } from '../build/buildQuickPayload';
import { DEV_TOOLS_COMBOBOX_PROPS } from '../shared/comboboxProps';

type ExposureQuickFormProps = {
  value: ExposureQuickFormState;
  onChange: (next: ExposureQuickFormState) => void;
};

export function ExposureQuickForm({ value, onChange }: ExposureQuickFormProps) {
  const mapOptions = scenarioMaps.exposure ?? [];
  const spawnOptions = getExposureSpawnPositions(value.map);
  const stats = previewExposureItemStats(value);

  return (
    <Stack gap='xs'>
      <Select
        label='Scenario'
        data={mapOptions}
        value={value.map}
        onChange={v => {
          const map = v ?? mapOptions[0]?.value ?? '';
          const spawns = getExposureSpawnPositions(map);
          onChange({
            ...value,
            map,
            userSpawnPosition: spawns[0]?.value ?? '1',
          });
        }}
        required
        comboboxProps={DEV_TOOLS_COMBOBOX_PROPS}
      />
      {spawnOptions.length > 0 && (
        <Select
          label='Posizione'
          data={spawnOptions}
          value={value.userSpawnPosition}
          onChange={v =>
            onChange({
              ...value,
              userSpawnPosition: v ?? spawnOptions[0].value,
            })
          }
          comboboxProps={DEV_TOOLS_COMBOBOX_PROPS}
        />
      )}
      <Switch
        label='Tutorial'
        checked={value.hasTutorial}
        onChange={e =>
          onChange({ ...value, hasTutorial: e.currentTarget.checked })
        }
      />
      <Switch
        label='Modalità buffet (multi-item)'
        checked={value.multiItem}
        onChange={e =>
          onChange({ ...value, multiItem: e.currentTarget.checked })
        }
      />
      <Text size='xs' fw={600}>
        Inclusione elementi
      </Text>
      <Group gap='sm'>
        {EXPOSURE_CATEGORY_OPTIONS.map(opt => (
          <Checkbox
            key={opt.value}
            label={opt.label}
            checked={value.categories[opt.value]}
            onChange={e =>
              onChange({
                ...value,
                categories: {
                  ...value.categories,
                  [opt.value]: e.currentTarget.checked,
                },
              })
            }
          />
        ))}
      </Group>
      <Text size='xs' c='dimmed'>
        {stats.itemCount} elementi
        {stats.groupCount != null ? ` · ${stats.groupCount} gruppi` : ''}
        {value.multiItem ? ' (4 per gruppo)' : ''}
      </Text>
    </Stack>
  );
}
